<template>
   <VContent>
       <h1>
           {{$store.state.user}}
       </h1>
   </VContent>
</template>

<script>
  export default {
    components: {},
    name: "Authenticated",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>